export const CHART_COLORS = {
  primary: '#2BA8E0',
  gradient: {
    start: '#2BA8E0',
    end: '#2BA8E0',
  },
} as const

export const createChartGradient = (color: string = CHART_COLORS.primary) => ({
  id: 'colorGradient',
  x1: '0',
  y1: '0',
  x2: '0',
  y2: '1',
  stops: [
    { offset: '5%', stopColor: color, stopOpacity: 0.8 },
    { offset: '95%', stopColor: color, stopOpacity: 0.1 },
  ],
})

export const ChartGradient = ({ color = CHART_COLORS.primary }: { color?: string }) => {
  const gradient = createChartGradient(color)
  return (
    <linearGradient {...gradient}>
      {gradient.stops.map((stop, index) => (
        <stop key={index} {...stop} />
      ))}
    </linearGradient>
  )
}
